import { render, staticRenderFns } from "./StaffTable.vue?vue&type=template&id=32d51618&"
import script from "./StaffTable.vue?vue&type=script&lang=js&"
export * from "./StaffTable.vue?vue&type=script&lang=js&"
import style0 from "./StaffTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/StaffTable.vue
// module id = null
// module chunks = 